import React from 'react';
import clsx from 'clsx';
import { useTranslation } from '@i18n';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

import { breakPointsUp } from '@helper_theme';
import Button from '@common_button';
import useStyles from '@common_sellerdialog/style';

const ConfirmationModal = (props) => {
    const { t } = useTranslation('common');
    const {
        open,
        title = '',
        children,
        action,
        justifyAction = 'right',
        onClose = () => {},
        leftButtonLabel = t('common:Cancel'),
        showLeftButton = true,
        onLeftButtonClick,
        disableLeftButton = false,
        buttonLeftType = 'outlined',
        rightButtonLabel = t('common:OK'),
        showRightButton = true,
        onRightButtonClick = () => {},
        disableRightButton = false,
        buttonRightType = 'primary',
        maxWidth = 'xs',
        useCloseIcon = true,
        hideAction = false,
        enableClickOutside = true,
        dialogProps = {},
        dialogContentProps = {},
        dialogTitleProps = {},
        dialogActionsProps = {},
        paperClasses = {},
    } = props;

    const classes = useStyles();
    const isDesktop = breakPointsUp('sm');

    return (
        <Dialog
            open={open}
            onClose={enableClickOutside && onClose}
            classes={{ paper: clsx(classes.dialogContainer, paperClasses), root: classes.dialogContainerRoot }}
            fullWidth
            maxWidth={maxWidth}
            fullScreen={!isDesktop}
            scroll="paper"
            {...dialogProps}
        >
            {useCloseIcon
                && (
                    <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                )}
            <DialogTitle classes={{ root: classes.titleSection }} disableTypography {...dialogTitleProps}>
                <div className={classes.header}>{title}</div>

            </DialogTitle>
            <DialogContent classes={{ root: classes.contentSection }} {...dialogContentProps}>
                {children}
            </DialogContent>
            {!hideAction
            && (
                <DialogActions classes={{ root: clsx(classes.dialogActions, justifyAction) }} disableSpacing {...dialogActionsProps}>
                    {action || (
                        <>
                            <Button
                                className={!showLeftButton && 'hide'}
                                onClick={onLeftButtonClick || onClose}
                                buttonType={buttonLeftType}
                                disabled={disableLeftButton}
                                user="seller"
                                fullWidth={!isDesktop}
                            >
                                {leftButtonLabel}
                            </Button>
                            <Button
                                className={!showRightButton && 'hide'}
                                onClick={onRightButtonClick}
                                buttonType={buttonRightType}
                                disabled={disableRightButton}
                                user="seller"
                                fullWidth={!isDesktop}
                            >
                                {rightButtonLabel}
                            </Button>
                        </>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default ConfirmationModal;
